import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

export const getLandingPageConfig = async () => {
  try {
    const url = ApiService.icdc.module.landingPage.getConfig;

    const response = await HttpService.post(url, {BusinessUnitCode: ''});
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error.message;
  }
};

export const getContentList = () => {
  return HttpService.post(ApiService.icdc.module.landingPage.getListContent, {
    contentTitle: '',
    page: 1,
    take: 100
  });
};

export const getSectionType = () => {
  return HttpService.post(
    ApiService.icdc.module.landingPage.getSectionType,
    {}
  );
};

export const saveLandingPageConfig = (data) => {
  return HttpService.post(ApiService.icdc.module.landingPage.saveConfig, {
    ...data
  });
};
